<lib-modal-layout [title]="'Are You Sure?'" [subtitle]="''">
  <div class="text-center my-10 small-text">
    <p>Deleting this document will permanantly remove it from the submission.</p>
    <p>This action can't be undone.</p>
  </div>
  <div class="text-center">
    <lib-button [cssType]="'btn-primary'" [text]="'Delete'" (click)="delete()"></lib-button>
  </div>
</lib-modal-layout>